import { ForumListItem } from './ForumListItem/ForumListItem';
import { AppViewerOverrides } from '../types';
import { ForumApp as app } from './app';

export const ForumAppUI: AppViewerOverrides = {
  documentType: app.documentType,
  Item: ForumListItem,
};
